import Saphirre1 from '../../../media/fasad/Ruko-Saphirre.webp'
import Saphirre2 from '../../../media/fasad/Ruko-Saphirre.webp'


const Saphirreimages =[
Saphirre1,Saphirre2
]

export default Saphirreimages;